import Resource from '@/api/resources/Resource'

class SampleProcessingFixerService extends Resource {
    async getSampleFixers(laboratoryId, sampleTypeId) {
        return this.axios.get(`/sampleProcessing/laboratories/${laboratoryId}/fixers/index`, {
            params: {
                sampleTypeId
            }
        }).then(response => response.data)
    }
}

export default new SampleProcessingFixerService()
